import {
  SET_INVOICE_TEMPLATE_LOADING,
  SET_INVOICES_TEMPLATE_LIST,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  isError: false,
  loading: false,
  // success: null,
  error: null,
};

const InvoiceTemplates = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_INVOICES_TEMPLATE_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SET_INVOICE_TEMPLATE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    default:
      return state;
  }
};

export default InvoiceTemplates;
